@if (partner) {
  <div class="card shadow border-0 mb-3 tab-pane fade fade-in-zoom active show" role="tabpanel">
    <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex justify-content-between align-items-center">
      <h2 class="fs-6 fw-bold mb-0">
        <i class="bi bi-basket me-2 text-primary"></i>Offers
      </h2>
    </div>

    <div class="card-body">
      <app-input-switch [ngModel]="partner.allOffersAccess" (change)="onChangeAccess($event)">All offers approved
      </app-input-switch>
      @if (!partner.allOffersAccess) {
        <div class="bg-tertiary p-2 border-start border-warning border-5 mt-5"><h3 class="fw-bold fs-6 mb-0">Authorized
          offers</h3>
        </div>
        <form [formGroup]="form" class="d-flex mt-3" (submit)="onSubmit()">
          <input type="text" class="form-control me-2" formControlName="subid"
                 placeholder="Sub ID (Leave empty to allow all)">
          <select class="form-select me-2" formControlName="offer">
            <option [ngValue]="null" disabled>Select offer</option>
            @for (offer of offers; track offer) {
              <option [ngValue]="offer">{{ offer }}</option>
            }
          </select>
          <button class="btn btn-primary fw-bold text-nowrap" type="submit">Add offer</button>
        </form>
        <div class="table-responsive">
          <table class="table table-striped table-hover align-middle mt-5">
            <thead>
            <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
              <th tableSorterHeader="subid">SubID</th>
              <th tableSorterHeader="offer">Offer</th>
              <th class="text-end">Actions</th>
            </tr>
            </thead>
            <tbody>
              @for (partnerOffer of partnerOffers; track partnerOffer) {
                <tr>
                  <td
                    [ngClass]="{'all-subid':!partnerOffer.subid}">{{ partnerOffer.subid ? partnerOffer.subid : 'All' }}
                  </td>
                  <td>{{ partnerOffer.offer }}</td>
                  <td class="text-end">
                    <button (click)="delete(partnerOffer)" class="btn btn-outline-danger btn-sm" appConfirm><i
                      class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
      }
    </div>
  </div>
}
